//@ts-check
import { createSlice } from "@reduxjs/toolkit";
import {
  DIALOG_TYPE,
  DialogOptions,
} from "apps/company/components/common/modal/dialog";

type InitialState = {
  show: boolean;
  options: DialogOptions;
};

const initialState: InitialState = {
  show: false,
  options: {
    modalType: DIALOG_TYPE.template,
  },
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    toggleModal: (
      state,
      action: {
        type: string;
        payload: DialogOptions;
      }
    ) => {
      state.show = !state.show;
      state.options = action.payload;
    },
  },
});

export const { toggleModal } = modalSlice.actions;

export default modalSlice.reducer;
